<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { audioEngine } from '../../audio/AudioEngine'

const props = withDefaults(defineProps<{ trackId: number; horizontal?: boolean }>(), {
  horizontal: false
})

const level = ref(0)
let rafId: number | null = null

const tick = () => {
  level.value = audioEngine.getTrackLevel(props.trackId)
  rafId = requestAnimationFrame(tick)
}

onMounted(() => { rafId = requestAnimationFrame(tick) })
onUnmounted(() => { if (rafId !== null) cancelAnimationFrame(rafId) })

const gradientStyle = computed(() => ({
  background: props.horizontal
    ? 'linear-gradient(to right, #10b981 0%, #10b981 70%, #facc15 70%, #facc15 90%, #ef4444 90%, #ef4444 100%)'
    : 'linear-gradient(to top, #10b981 0%, #10b981 70%, #facc15 70%, #facc15 90%, #ef4444 90%, #ef4444 100%)'
}))

const maskStyle = computed(() => {
  const inverse = `${100 - Math.min(level.value * 100, 100)}%`
  return props.horizontal
    ? { width: inverse, top: '0', bottom: '0', right: '0' }
    : { height: inverse, left: '0', right: '0', top: '0' }
})
</script>

<template>
  <div class="track-meter relative w-full h-full overflow-hidden">
    <div class="absolute inset-0" :style="gradientStyle"></div>
    <div class="track-meter-mask absolute" :style="maskStyle"></div>
  </div>
</template>
